export default __webpack_public_path__ + "static/Lyndon-Wood-c5bc29c876ea2184d3198c4acc6e780f.png";